/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssistantChatPostRequestMessagePartsInner } from './AssistantChatPostRequestMessagePartsInner';
import {
    AssistantChatPostRequestMessagePartsInnerFromJSON,
    AssistantChatPostRequestMessagePartsInnerFromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerToJSON,
    AssistantChatPostRequestMessagePartsInnerToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInner';
import type { AssistantChatPostRequestMessageRole } from './AssistantChatPostRequestMessageRole';
import {
    AssistantChatPostRequestMessageRoleFromJSON,
    AssistantChatPostRequestMessageRoleFromJSONTyped,
    AssistantChatPostRequestMessageRoleToJSON,
    AssistantChatPostRequestMessageRoleToJSONTyped,
} from './AssistantChatPostRequestMessageRole';

/**
 * 
 * @export
 * @interface AssistantChatPostRequestMessage
 */
export interface AssistantChatPostRequestMessage {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessage
     */
    id: string;
    /**
     * 
     * @type {AssistantChatPostRequestMessageRole}
     * @memberof AssistantChatPostRequestMessage
     */
    role: AssistantChatPostRequestMessageRole;
    /**
     * 
     * @type {Array<AssistantChatPostRequestMessagePartsInner>}
     * @memberof AssistantChatPostRequestMessage
     */
    parts: Array<AssistantChatPostRequestMessagePartsInner>;
}

/**
 * Check if a given object implements the AssistantChatPostRequestMessage interface.
 */
export function instanceOfAssistantChatPostRequestMessage(value: object): value is AssistantChatPostRequestMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('parts' in value) || value['parts'] === undefined) return false;
    return true;
}

export function AssistantChatPostRequestMessageFromJSON(json: any): AssistantChatPostRequestMessage {
    return AssistantChatPostRequestMessageFromJSONTyped(json, false);
}

export function AssistantChatPostRequestMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantChatPostRequestMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'role': AssistantChatPostRequestMessageRoleFromJSON(json['role']),
        'parts': ((json['parts'] as Array<any>).map(AssistantChatPostRequestMessagePartsInnerFromJSON)),
    };
}

export function AssistantChatPostRequestMessageToJSON(json: any): AssistantChatPostRequestMessage {
    return AssistantChatPostRequestMessageToJSONTyped(json, false);
}

export function AssistantChatPostRequestMessageToJSONTyped(value?: AssistantChatPostRequestMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'role': AssistantChatPostRequestMessageRoleToJSON(value['role']),
        'parts': ((value['parts'] as Array<any>).map(AssistantChatPostRequestMessagePartsInnerToJSON)),
    };
}

